import { NgClass, NgStyle } from '@angular/common'
import { Component, computed, input, OnInit } from '@angular/core'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { Router } from '@angular/router'

import { Section, RedirectTilesContent, RedirectTile } from 'app/_shared/interfaces/config'

@Component({
  selector: 'app-redirect-tiles',
  imports: [NgStyle, NgClass],
  templateUrl: './redirect-tiles.component.html',
  styleUrl: './redirect-tiles.component.scss'
})
export class RedirectTilesComponent implements OnInit {
  section = input.required<Section<RedirectTilesContent>>()

  items = computed(() =>
    this.section()?.content?.items.filter(item =>
      item.visible !== undefined ? item.visible : true
    )
  )

  safeTitle: SafeHtml

  constructor(
    private router: Router,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    const content = this.section()?.content
    if (content?.title) {
      this.safeTitle = this.sanitizer.bypassSecurityTrustHtml(content.title)
    }
  }

  onTileClick(tile: RedirectTile): void {
    if (tile.redirectOnClick) {
      if (tile.categoriesOrPagesRedirect && tile.item) {
        // Navigate internally based on the type of item.
        if (tile.item.type === 'category') {
          // For a category, navigate to 'categories/{url}'
          this.router.navigate(['categories', tile.item.url])
        } else if (tile.item.type === 'page') {
          // For a page, navigate to the provided URL
          this.router.navigateByUrl(tile.item.url)
        }
      } else if (tile.redirectUrl) {
        // External redirection
        let url = tile.redirectUrl
        if (!/^https?:\/\//i.test(url)) {
          url = 'https://' + url
        }
        window.open(url, '_blank')
      }
    }
  }

  getColClass(tilesInRow: number | undefined): string {
    switch (tilesInRow) {
      case 1:
        return 'col-12'
      case 2:
        return 'col-6'
      case 3:
        return 'col-4'
      case 4:
        return 'col-3'
      default:
        return 'col'
    }
  }

  getJustifyContent(): string {
    const alignment = this.section()?.content?.tilesAlignment || 'left'
    if (alignment === 'center') {
      return 'center'
    } else if (alignment === 'right') {
      return 'flex-end'
    } else {
      return 'flex-start'
    }
  }
}
